import script from "./TransactionCategoryChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionCategoryChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__